module.exports = __webpack_public_path__ + "media/images/app-0ff1d82b79d206fc4dc424dd04c02984.png";